@switch (columnName) {
  @case ('id') {
    {{ element['number'] }}
  }
  @case ('status') {
    @if (!element.deleted && element.enabled) {
      @if (element['secondaryStatusDisplayName']) {
        <app-ui-pill [customLabel]="true" [name]="element['statusDisplayClass']">
          @if (element['statusDisplayUppercase']) {
            {{ element['statusDisplayName'] | translate | uppercase }}
          } @else {
            {{ element['statusDisplayName'] | translate | titlecase }}
          }
          / {{ element['secondaryStatusDisplayName'] | translate | titlecase }}
        </app-ui-pill>
      } @else {
        <app-ui-pill [name]="element['statusDisplayName'] | lowercase"></app-ui-pill>
      }
    } @else {
      @if (!element.enabled) {
        <app-ui-pill [name]="'disabled' | lowercase"></app-ui-pill>
      } @else {
        @if (element.deleted) {
          <app-ui-pill [name]="'deleted' | lowercase"></app-ui-pill>
        }
      }
    }
  }
  @case ('nextRevisionDate') {
    {{ element[columnName] | date }}
  }
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('responsible') {
    <app-text-overflow-label [text]="element.responsibleOwnerName ?? ''"></app-text-overflow-label>
  }
  @case ('readReceiptSummary') {
    @if (getReadReceiptSummaryLabel(element); as summaryLabel) {
      <div class="read-receipt-summary">
        <app-ui-pill [customLabel]="true" [name]="getReadReceiptSummaryStatusClass(element)">
          {{ summaryLabel }}
        </app-ui-pill>
      </div>
    }
  }
  @case ('hasReadCurrentReadReceipt') {
    @if (element.hasReadCurrentReadReceipt === false) {
      <div class="read-receipt-status read-receipt-status--unread">
        <mat-icon>visibility_off</mat-icon>
      </div>
    }
  }
  @case ('versionComment') {
    @if (getRevisionCommentPreview(element.versionComment); as preview) {
      @if (preview !== '') {
        <span
          [matTooltip]="getRevisionCommentTooltipText(element.versionComment)"
          [matTooltipDisabled]="!revisionCommentTooltipEnabled(element.versionComment)"
          matTooltipShowDelay="300"
        >
          {{ preview }}
        </span>
      }
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
